import BoardOrLoopPreviewController from 'webapp/controllers/boards/board-or-loop-preview';

import type Board from 'webapp/models-custom/board';

export default class BoardsViewBoardController extends BoardOrLoopPreviewController {
	declare model: Board;
	rootUrlWithoutId = '/databoards/view';
}
